import ErrorBase, { ErrorSeverity } from './ErrorBase';
export default class InvalidParametersException extends ErrorBase {
    constructor(loggingDetails = {}) {
        super('Invalid parameters.', loggingDetails, ErrorSeverity.WARNING);
        this.name = 'InvalidParametersException';
    }
}
